// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__12Lb5","containerItemsCenter":"Skeleton_containerItemsCenter__15Ux2"};